import { TAppState } from '../types';
import { selectSubscriptionLevel } from './buyPackageModal';

export const selectProlongSubscriptionParameters = (state: TAppState) => {
  const level = selectSubscriptionLevel(state);

  return {
    level,
  };
};
